import { openBlock as t, createElementBlock as a, createStaticVNode as c } from "vue";
const e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, l = /* @__PURE__ */ c('<path fill="#000" d="M40 20c0-.884-.058-1.755-.17-2.609H17.392L5.858 5.858c-7.81 7.81-7.81 20.474 0 28.284L17.39 22.61h22.44c.11-.854.169-1.725.169-2.609Z"></path><path fill="#D80027" d="M39.83 17.391c.01.069.017.138.026.206C38.669 7.685 30.232 0 20 0A19.936 19.936 0 0 0 5.858 5.858L17.39 17.39h22.44Z"></path><path fill="#6DA544" d="M39.83 22.609H17.392L5.858 34.142A19.936 19.936 0 0 0 20 40c10.232 0 18.669-7.685 19.856-17.597l-.025.206Z"></path><path fill="#FFDA44" d="M39.98 19.123H16.657L4.676 7.143c-.388.41-.808.98-1.067 1.386l11.457 11.464L3.6 31.46c.227.404.722 1.002 1.069 1.39l11.989-11.988h23.327a20.09 20.09 0 0 0-.003-1.739Z"></path><path fill="#FFDA44" d="M4.858 24.263v-1.675a3.035 3.035 0 0 0 3.032-3.032 2.147 2.147 0 0 0-2.145-2.145c-.806 0-1.461.656-1.461 1.462 0 .515.419.934.934.934a.529.529 0 0 0 .528-.528h1.676a2.206 2.206 0 0 1-2.204 2.203 2.612 2.612 0 0 1-2.61-2.609 3.14 3.14 0 0 1 3.137-3.136 3.824 3.824 0 0 1 3.82 3.82 4.712 4.712 0 0 1-4.707 4.706Z"></path>', 5), h = [
  l
];
function o(n, p) {
  return t(), a("svg", e, [...h]);
}
const d = { render: o };
export {
  d as default,
  o as render
};
